export default {
  SET_CREDITS: function (state, payload) {
    state.credits = payload;
  }
}
